import './tempTransaction.css';
import { Outlet } from 'react-router-dom';

function TempTransaction() {
  return (
    <div>
      <Outlet></Outlet>
    </div>
  );
}

export default TempTransaction;
